import type { SliceComponentProps } from '@commercekit/prismic';
import React from 'react'
import type { ImageAndTextContentSlice } from '~/lib/prismic/types.generated';
import LeftImageAndRightText from './variations/LeftImageAndRightText';
import RightImageAndLeftText from './variations/RightImageAndLeftText';

const ImageAndTextContent = ({ slice }: SliceComponentProps<ImageAndTextContentSlice>) => {
  switch (slice.variation) {
    case "default": {
      return <LeftImageAndRightText slice={slice} />;
    }
    case "imageRight": {
      return <RightImageAndLeftText slice={slice} />;
    }
  }
}
 ;

export default ImageAndTextContent;
